import React, { useEffect, useState } from "react";
import clienteAxios from "../../axios";
import ModalConfirm from "../ModalConfirm"; // Modal de confirmación
import ModalAgregarEmpleado from "./ModalAgregarEmpleado"; // Modal para agregar empleados

const Empleados = ({ restauranteId }) => {
    const [empleados, setEmpleados] = useState([]);
    const [mostrarEmpleados, setMostrarEmpleados] = useState(false); // Controla la visibilidad de empleados
    const [empleadoSeleccionado, setEmpleadoSeleccionado] = useState(null);
    const [editandoEmpleado, setEditandoEmpleado] = useState(null);
    const [nuevoEmpleado, setNuevoEmpleado] = useState({
        nombre: "",
        apellido: "",
        puesto: "",
        salario: "",
        fecha_contratacion: ""
    });
    const [showConfirmModal, setShowConfirmModal] = useState(false); // Modal de confirmación
    const [showAgregarEmpleadoModal, setShowAgregarEmpleadoModal] = useState(false); // Modal para agregar empleado
    const [busqueda, setBusqueda] = useState(""); // Para controlar la búsqueda


    // Obtener la lista de empleados
    const obtenerEmpleados = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Listar",
                modulo: "empleados"
            });
            setEmpleados(response.data.data[0].filter(empleado => empleado.restaurante_id === restauranteId)); // Filtrar por restaurante
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        obtenerEmpleados();
    }, [restauranteId]);


    // Función para manejar la búsqueda
    const handleBusqueda = (e) => {
        setBusqueda(e.target.value.toLowerCase());
    };

    // Función para filtrar empleados por nombre o apellido
    const empleadosFiltrados = empleados.filter((empleado) =>
        empleado.nombre.toLowerCase().includes(busqueda) ||
        empleado.apellido.toLowerCase().includes(busqueda)
    );


    // Función para agregar un nuevo empleado
    const handleAgregarEmpleado = async (e) => {
        e.preventDefault();
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Agregar",
                modulo: "empleados",
                restaurante_id: restauranteId,
                ...nuevoEmpleado
            });
            setNuevoEmpleado({
                nombre: "",
                apellido: "",
                puesto: "",
                salario: "",
                fecha_contratacion: ""
            });
            setShowAgregarEmpleadoModal(false);
            obtenerEmpleados();
        } catch (error) {
            console.log(error);
        }
    };

    const onEmpleadoAgregado = () => {
        obtenerEmpleados(); // Actualiza la lista de empleados
        setShowAgregarEmpleadoModal(false); // Cierra el modal
    };

    // Función para editar un empleado
    const editarEmpleado = (empleado) => {
        setEditandoEmpleado(empleado);
    };

    const guardarEmpleadoEditado = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Actualizar",
                modulo: "empleados",
                id: editandoEmpleado.id,
                ...editandoEmpleado
            });
            setEditandoEmpleado(null);
            obtenerEmpleados();
        } catch (error) {
            console.log(error);
        }
    };

    // Función para eliminar un empleado
    const confirmarEliminarEmpleado = (empleado) => {
        setEmpleadoSeleccionado(empleado);
        setShowConfirmModal(true); // Mostrar modal de confirmación
    };

    const eliminarEmpleado = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Eliminiar", // Asegúrate de que la operación tenga la ortografía correcta
                modulo: "empleados",
                id: empleadoSeleccionado.id
            });
            setShowConfirmModal(false);
            obtenerEmpleados();
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div>

            <div className="mt-4 border p-4 rounded-lg">
                <h3 className="text-lg font-semibold">Empleados del Restaurante</h3>


                {/* Barra de búsqueda */}
                <input
                    type="text"
                    placeholder="Buscar empleado por nombre o apellido..."
                    value={busqueda}
                    onChange={handleBusqueda}
                    className="border rounded-lg p-2 mb-4 mt-4 w-1/2 min-w-[200px]"
                />


                <button
                    onClick={() => setShowAgregarEmpleadoModal(true)}
                    className="bg-blue-500 text-white rounded px-4 py-2 mt-4 ml-2 ml-6 hover:bg-blue-400"
                >
                    Agregar Nuevo Empleado
                </button>

                <ul>
                    {empleadosFiltrados.map((empleado) => (
                        <li key={empleado.id} className="border p-2 mb-2 mt-4">
                            {editandoEmpleado && editandoEmpleado.id === empleado.id ? (
                                <>
                                    <div className="flex flex-col">
                                        <h3 className=" font-semibold mt-2">Nombre:</h3>
                                        <input
                                            type="text"
                                            value={editandoEmpleado.nombre}
                                            onChange={(e) =>
                                                setEditandoEmpleado({ ...editandoEmpleado, nombre: e.target.value })
                                            }
                                            className="border rounded-lg p-2 mr-2"
                                            maxLength={50}
                                        />
                                        <h3 className=" font-semibold mt-2">Apellido:</h3>
                                        <input
                                            type="text"
                                            value={editandoEmpleado.apellido}
                                            onChange={(e) =>
                                                setEditandoEmpleado({ ...editandoEmpleado, apellido: e.target.value })
                                            }
                                            className="border rounded-lg p-2 mr-2"
                                            maxLength={50}
                                        />
                                        <h3 className=" font-semibold mt-2">Puesto:</h3>
                                        <input
                                            type="text"
                                            value={editandoEmpleado.puesto}
                                            onChange={(e) =>
                                                setEditandoEmpleado({ ...editandoEmpleado, puesto: e.target.value })
                                            }
                                            className="border rounded-lg p-2 mr-2"
                                            maxLength={50}
                                        />
                                        <h3 className=" font-semibold mt-2">Salario:</h3>
                                        <input
                                            type="number"
                                            value={editandoEmpleado.salario}
                                            onChange={(e) =>
                                                setEditandoEmpleado({ ...editandoEmpleado, salario: e.target.value })
                                            }
                                            className="border rounded-lg p-2 mr-2"
                                            maxLength={20}
                                        />

                                        <div className="flex mt-4 mb-2">
                                            <button
                                                onClick={guardarEmpleadoEditado}
                                                className="bg-green-500 text-white rounded px-2 py-1 mt-2 w-40 mr-2"
                                            >
                                                Guardar
                                            </button>
                                            <button
                                                onClick={() => setEditandoEmpleado(null)}
                                                className="bg-gray-500 text-white rounded px-2 py-1 mt-2 w-40"
                                            >
                                                Cancelar
                                            </button>
                                        </div>
                                    </div>
                                </>

                            ) : (
                                <>
                                
                                    <span><strong>Nombre:</strong> {empleado.nombre} {empleado.apellido}</span><br />
                                    <span><strong>Empleado ID:</strong> {empleado.id}</span><br />
                                    <span><strong>Puesto:</strong> {empleado.puesto}</span><br />
                                    <span><strong>Salario:</strong> {empleado.salario}</span><br />
                                    <span><strong>Fecha de contratación:</strong> {empleado.fecha_contratacion}</span><br />
                                    <button
                                        onClick={() => editarEmpleado(empleado)}
                                        className="bg-gray-500 text-white rounded px-2 py-1 mt-2 hover:bg-gray-400"
                                    >
                                        Editar
                                    </button>
                                    <button
                                        onClick={() => confirmarEliminarEmpleado(empleado)}
                                        className="bg-red-600 text-white rounded px-2 py-1 mt-2 ml-2 hover:bg-red-500"
                                    >
                                        Eliminar
                                    </button>
                                </>
                            )}
                        </li>
                    ))}
                </ul>
            </div>

            {/* Modal de confirmación para eliminar */}
            <ModalConfirm
                show={showConfirmModal}
                message="¿Estás seguro de que quieres eliminar este empleado?"
                onConfirm={eliminarEmpleado}
                onCancel={() => setShowConfirmModal(false)}
            />

            {/* Modal para agregar un nuevo empleado */}
            <ModalAgregarEmpleado
                show={showAgregarEmpleadoModal}
                onClose={() => setShowAgregarEmpleadoModal(false)}
                restauranteId={restauranteId} // Pasa el restauranteId
                onEmpleadoAgregado={onEmpleadoAgregado} // Asegúrate de pasar esta función
            />
        </div>
    );
};

export default Empleados;
